import { HStack, Stack, Tabs, VStack } from '@chakra-ui/react';
import SavedDocumentsList from './SavedDocumentsList';
import RAGChat from './RAGChat';
import { useAppDispatch, useAppSelector } from '../../lib/hooks';

import PersistentBar from './PersistentBar';
import SearchTool from './SearchTool';

export default function Toolbar() {
  const toolOpenStatus = useAppSelector((state) => state.viewReducer.toolOpenStatus);

  const open = Object.keys(toolOpenStatus).reduce(
    (p, c: string) => p && (toolOpenStatus as any)[c],
    true,
  );

  return (
    <HStack
      height={'100%'}
      gap={0}
    >
      <VStack
        height={'100%'}
        background="background"
      >
        {toolOpenStatus.search && <SearchTool />}
        {toolOpenStatus.savedCases && <SavedDocumentsList />}
        {toolOpenStatus.aiChat && <RAGChat />}
      </VStack>

      <PersistentBar />
    </HStack>
  );
}
